import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type InitialStateTypes = {
	addressTab: addressTab
}

type addressTab = `map` | `list`

const initialState = {
	addressTab: `map`
} as InitialStateTypes

const address = createSlice({
	name: `address`,
	initialState,
	reducers: {
		changeAddressTab: (state, action: PayloadAction<addressTab>) => {
			state.addressTab = action.payload
		}
	}
})

export const { changeAddressTab } = address.actions
export default address.reducer
